import FooterDrawerMenu from './FooterDrawerMenu';

export default FooterDrawerMenu;
